import React from "react";
import io from "socket.io-client";
import { btoa } from "./cryptographic/crypto";
import { getCookie, updateCookie } from "./views/utility/cookies";

let socketvar = null;

function generateRandomString() {
    const now = new Date();
    const timestamp = now.getTime();
    const randomNumber = Math.floor(Math.random() * 1000000);
    const randomString = `${timestamp}${randomNumber}`;
    return randomString;
}

if (window.chat_widget_reference_no) {
    localStorage.setItem('groupId', window.chat_widget_reference_no)
    window.groupId = window.chat_widget_reference_no;
}
var locale = 'en'
if (getCookie('prefLang') === null || getCookie('prefLang') === '' || getCookie('prefLang') === undefined || getCookie('prefLang') === false) {
    locale = 'en'
}
else {
    locale = getCookie('prefLang')
}
let newSessionId = ''
if (getCookie('sessionId')) {
    newSessionId = getCookie('sessionId')
}else {
    newSessionId = generateRandomString()
    updateCookie("sessionId", newSessionId)
}


const botType = process.env.REACT_APP_PROD === "true" ? window.bot_type : process.env.REACT_APP_TYPE
const socketQuery = {
    type: 'user',
    page: 'chat',
    locale: locale,
    group: process.env.REACT_APP_PROD === "true" ? window.groupId : process.env.REACT_APP_GROUPID, //csu
    
}

if(botType === "TlkDocs"){
    socketQuery.session_id = window.sessionId
    socketQuery.platform = "talkkmesanger"
}else{
    socketQuery.session_id = newSessionId
}

socketvar = io(process.env.REACT_APP_API_CHAT_BASE_URL, {
    transports: ['websocket', 'polling'],
    path: '/talkk',
    // reconnection: false,
    // upgrade:true,
    multiplex: true,
    query: {q:btoa(socketQuery)},
});
var onevent = socketvar.onevent;
socketvar.on("connect", async () => {
    console.log(`Client connected Here 25: ${socket.id}`);
    console.log("check first connection")
    socketvar.onevent = function (packet) {
        var args = packet.data || [];
        onevent.call(this, packet); // original call
        packet.data = ["*"].concat(args);
        onevent.call(this, packet); // additional call to catch-all
    };
});
socketvar.on("disconnect", (e) => {
    // socketvar.removeAllListeners();
    console.log(`Client disconnected here 25: ${e}`)
    return;
});

socketvar.on("connect_error", (e) => {
    console.log(`Client connect_error:`, e)
    return;
});


export var socket = socketvar;
export var SocketContext = React.createContext(socket);
